import { Stack } from '@mui/material';
import React from 'react';

import AdChoices from './fields/AdChoices';
import AdType from './fields/AdType';
import Associated from './fields/Associated';
import Category from './fields/Category';
import CustomSchedule from './fields/CustomSchedule';
import GenerateATag from './fields/GenerateATag';
import Html from './fields/momentNativeAd/Html';
import Size from './fields/momentNativeAd/Size';
import Url from './fields/momentNativeAd/Url';
import Name from './fields/Name';
import Properties from './fields/Properties';
import ThirdPartyTagIds from './fields/ThirdPartyTagIds';
import Variables from './fields/Variables';

interface MomentProps {
  adGroupId?: number;
}

export default function Moment({ adGroupId }: MomentProps) {
  return (
    <Stack spacing={2}>
      <Name />
      {Boolean(adGroupId) && <Associated />}
      <Properties defaultValue={['88']} />
      <Category />
      <Stack direction="row" spacing={2}>
        <Size />
        <AdType />
      </Stack>
      <Stack direction="row" spacing={2}>
        <GenerateATag />
        <AdChoices />
      </Stack>
      <Url upload />
      <Html />
      <ThirdPartyTagIds />
      <CustomSchedule />
      <Variables />
    </Stack>
  );
}
